import { create } from 'zustand';

interface AppStore {
  appTitle: string;
  isLoading: boolean;
  error: {
    message: string;
    title: string;
    action: string;
    onCloseHandler: (() => void) | null;
  };
  setAppTitle: (title: string) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: {
    message: string;
    title?: string;
    action?: string;
    onCloseHandler?: (() => void) | null;
  }) => void;
  clearError: () => void;
}

const appStore = create<AppStore>((set) => ({
  appTitle: 'Bienvenidos',
  isLoading: false,
  error: {
    message: '',
    title: '',
    action: '',
    onCloseHandler: null,
  },
  setAppTitle: (title) => set({ appTitle: title }),
  setLoading: (loading) => set({ isLoading: loading }),
  setError: (error) => set((state) => ({
    error: {
      message: error.message,
      title: error.title ?? state.error.title,
      action: error.action ?? state.error.action,
      onCloseHandler: error.onCloseHandler ?? state.error.onCloseHandler,
    }
  })),
  clearError: () => set({
    error: {
      message: '',
      title: '',
      action: '',
      onCloseHandler: null,
    }
  }),
}));

export const useAppStore = appStore;
export default appStore;